import React from 'react'
import { Table } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'
import { ProjectImportColorCode } from '@/Services/MsProjectImportService'

type Props = {
  colorCodes: ProjectImportColorCode[]
  highlightedId: string | null
  taskCounts: Record<string, number>
  onUpdate: (id: string, field: 'name' | 'color', value: string) => void
}

const ColorCodesTab = ({ colorCodes, highlightedId, taskCounts, onUpdate }: Props) => {
  const { t } = useTranslation()

  if (!colorCodes.length) return <div className="text-muted py-3">{t('MS_PROJECT_IMPORTER:NoColorCodes')}</div>

  return (
    <>
      <h5>{t('MS_PROJECT_IMPORTER:ColorCodesPreview')}</h5>
      <Table bordered hover size="sm" responsive className="ms-project-importer-color-codes">
        <thead><tr><th>{t('MS_PROJECT_IMPORTER:OriginalCode')}</th><th>{t('MS_PROJECT_IMPORTER:ColorCodeName')}</th><th>{t('MS_PROJECT_IMPORTER:Color')}</th><th>{t('MS_PROJECT_IMPORTER:AssociatedTasks')}</th><th>{t('MS_PROJECT_IMPORTER:SourceSheet')}</th></tr></thead>
        <tbody>{colorCodes.map(code => (
          <tr key={code.id} data-color-code-id={code.id} className={highlightedId === code.id ? 'ms-project-importer-highlighted-row' : undefined}>
            <td>{code.sourceValue}</td>
            <td><input className="form-control form-control-sm" value={code.name} aria-label={t('MS_PROJECT_IMPORTER:ColorCodeName')} onChange={event => onUpdate(code.id, 'name', event.target.value)} /></td>
            <td><div className="ms-project-importer-color-editor"><input type="color" value={code.color} aria-label={t('MS_PROJECT_IMPORTER:Color')} onChange={event => onUpdate(code.id, 'color', event.target.value)} /><code>{code.color}</code></div></td>
            <td>{taskCounts[code.id] || 0}</td>
            <td>{code.sourceSheet} · {t('MS_PROJECT_IMPORTER:Row')} {code.firstSourceRow}</td>
          </tr>
        ))}</tbody>
      </Table>
    </>
  )
}

export default ColorCodesTab
